module.exports = __webpack_public_path__ + "img/3.be7d6afc.jpg";